<template>
    <div class="absolute flex flex-col z-50 left-5 bottom-5">
        <button
            class="p-2 bg-white dark:bg-slate-800 border-t border-l border-r rounded-t-md border-slate-200 hover:bg-slate-200 active:bg-slate-200 focus:ring-2 focus:ring-slate-200 transition-colors focus:outline-none"
            @click="$emit('zoomIn')"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
            >
                <path
                    d="M9.99967 5.83203V9.9987M9.99967 9.9987V14.1654M9.99967 9.9987H5.83301M9.99967 9.9987H14.1663"
                    stroke="#1E293B"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                />
            </svg>
            <span class="sr-only">Zoom in</span>
        </button>
        <hr class="border-0.5 border-slate-200" />
        <button
            class="p-2 bg-white dark:bg-slate-800 border-b border-l border-r rounded-b-md border-slate-200 hover:bg-slate-200 active:bg-slate-200 focus:ring-2 focus:ring-slate-200 transition-colors focus:outline-none mb-3"
            @click="$emit('zoomOut')"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
            >
                <path
                    d="M5.83301 10H14.1663"
                    stroke="#1E293B"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                />
            </svg>
            <span class="sr-only">Zoom out</span>
        </button>
        <button
            @click="$emit('reCenter')"
            class="p-2 bg-white dark:bg-slate-800 border rounded-md border-slate-200 hover:bg-slate-200 active:bg-slate-200 focus:ring-2 focus:ring-slate-200 transition-colors focus:outline-none"
        >
            <i class="fa-regular fa-crosshairs"></i>
            <span class="sr-only">Re-center</span>
        </button>
    </div>
</template>
<script setup></script>
